export interface ListingPage {
    id: number;
    name: string;
    permalink: string;
    emakiView: string;
    description: string;
    categories: string;
    contentTypes: string;
    tags: string;
    dateCreated: string;
    dateUpdated: string;
    isNotDeletable: boolean;
}
export enum HubPagePinnedHubPageSection {
    PRIMARY = 'primary',
    SECONDARY = 'secondary'
}

export enum HubPageConfig {
    ARTICLES = 'articles',
    TAGS = 'tags',
    HOMEPAGE_VIDEO = 'homepage_video',
    HOMEPAGE_THREAD = 'homepage_thread',
    VIDEO_CHANNEL = 'channel',
    TAG_HUB = 'tagHub'
}

export interface HubPagePinnedHubPage {

    uuid?:                      string,
    id:                         string,
    idListingPage:              number,
    listingPage:                object,
    idShowMoreListingPage:      number,
    showMoreListingPage:        object,
    showMoreListingPageFilter:  any,
    position:                   string,
    dateCreated:                string,
    alternateTitle:             string,
    enableEdit:                 boolean,
    pinnedSection?:             string
}

export interface HubPage {
    id:           number;
    name:         string;
    permalink:    string;
    description:  string;
    categories:   number[];
    contentTypes: number[];
    tags:         number[];
    listingPages: number[];
    type:         string;
    dateCreated:  string;
    dateUpdated:  string;
}

export interface HubPageSearchResult {
    uuid?:                 string;
    id:                    number;
    idListingPage:         number;
    listingPage:           HubPage;
    idShowMoreListingPage: number;
    showMoreListingPage:   HubPage;
    position:              number;
    dateCreated:           string;
    alternateTitle:        string;
}



// WEBPACK FOOTER //
// ./js/utils/types/listing_page.ts